<template lang="pug">
  app-dialog(v-model="$_show" header="Редактировать реквизиты" confirm-text="Сохранить" @confirm="edit")
    .advocatapp
        bankAccountItem(:form.sync="form")

</template>

<script>
import { AppDialogToggable } from '@/components'
import { specialistService } from '@/_services'
import bankAccountItem from './BankAccountItem'

export default {
  mixins: [AppDialogToggable],
  components: {
    bankAccountItem
  },
  props: {
    bankAccount: null,
  },
  data () {
    const defaultForm = Object.freeze({
      id: null,
      orgName: '',
      bill: '',
      bank: '',
      inn: '',
      address: '',
      kpp: '',
      bankBik: '',
      bankKpp: '',
      bankInn: '',
      bankBill: '',
      bankAddress: ''
    })

    return {
      form: Object.assign({}, defaultForm),
      defaultForm
    }
  },
  methods: {
    edit() {
      if(this.form.id!=null)
        specialistService.editBankAccount(this.form).then( data =>
           this.$emit('edit', data)
        )
    },
  },
  watch: {
    $_show (value) {
      if (value) {
        let baseObj = this.bankAccount || this.defaultForm
        this.form = JSON.parse(JSON.stringify(baseObj))
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>

